import { useEffect, useState, type ReactNode } from 'react'

interface ContentPanelProps {
  children: ReactNode
}

export function ContentPanel({ children }: ContentPanelProps) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.innerWidth < 768
  })

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768)
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <main className="absolute inset-0 flex h-full w-full flex-col z-10 bg-transparent">
      <div
        className={`min-h-0 min-w-0 flex-1 ${isMobile ? 'overflow-auto' : ''}`}>
        {children}
      </div>
    </main>
  )
}
